// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { InternalUserDetailFragmentDoc, DocumentDetailFragmentDoc, DocumentEditorDetailFragmentDoc, ScheduleTaskInfoFragmentDoc, NamedDevelopmentCohortsProjectsFragmentDoc, DocumentDetailDocumentTypeFragmentDoc } from '../../../fragments/circularFragments.generated';
import { AssetInfoFragmentDoc } from '../assets/AssetPreview.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DocumentsPageMetadataQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID']['input'];
  skipDevelopment: Types.Scalars['Boolean']['input'];
  skipProject: Types.Scalars['Boolean']['input'];
}>;


export type DocumentsPageMetadataQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }>, documentCategories: Array<{ __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory }>, development?: { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }> | null | undefined }, project?:
    | { __typename?: 'StandaloneProject', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Region', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Market', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Community', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Subdivision', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Lot', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Structure', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
    | { __typename?: 'Unit', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Region', id: string, name: string, parent?:
            | { __typename?: 'StandaloneProject', id: string }
            | { __typename?: 'Region', id: string }
            | { __typename?: 'Market', id: string }
            | { __typename?: 'Community', id: string }
            | { __typename?: 'Subdivision', id: string }
            | { __typename?: 'Lot', id: string }
            | { __typename?: 'Structure', id: string }
            | { __typename?: 'Unit', id: string }
           | null | undefined }
        | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
        | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
        | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
        | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
        | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
        | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
      > }
   };

export type DocumentsPageQueryVariables = Types.Exact<{
  filter: Types.DocumentsFilter;
  page: Types.PageFilter;
}>;


export type DocumentsPageQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsPageResult', entities: Array<{ __typename?: 'Document', id: string, name: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, parent:
        | { __typename?: 'Development', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
      , associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
      >, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type DocumentsAssetQueryVariables = Types.Exact<{
  filter: Types.DocumentsFilter;
}>;


export type DocumentsAssetQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export type ScheduleTasksForDocumentParentQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID']['input'];
}>;


export type ScheduleTasksForDocumentParentQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, parent:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Development', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
      | { __typename?: 'ScheduleTemplate' }
     }> };

export type DocumentEditorQueryVariables = Types.Exact<{
  documentId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DocumentEditorQuery = { __typename?: 'Query', document: { __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, parent:
      | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }> | null | undefined }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
      | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Region', id: string, name: string, parent?:
              | { __typename?: 'StandaloneProject', id: string }
              | { __typename?: 'Region', id: string }
              | { __typename?: 'Market', id: string }
              | { __typename?: 'Community', id: string }
              | { __typename?: 'Subdivision', id: string }
              | { __typename?: 'Lot', id: string }
              | { __typename?: 'Structure', id: string }
              | { __typename?: 'Unit', id: string }
             | null | undefined }
          | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
          | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
          | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
          | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
          | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
          | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
        > }
    , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> };

export type DocumentsForParentQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID']['input'];
}>;


export type DocumentsForParentQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, name: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, parent:
      | { __typename?: 'Development', id: string }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
    , associatedProjects: Array<
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
    >, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export type DocumentCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DocumentCategoriesQuery = { __typename?: 'Query', documentCategories: Array<{ __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory }> };

export type SaveDocumentsMutationVariables = Types.Exact<{
  input: Array<Types.SaveDocumentInput> | Types.SaveDocumentInput;
}>;


export type SaveDocumentsMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', id: string, name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Region', id: string, name: string, parent?:
                | { __typename?: 'StandaloneProject', id: string }
                | { __typename?: 'Region', id: string }
                | { __typename?: 'Market', id: string }
                | { __typename?: 'Community', id: string }
                | { __typename?: 'Subdivision', id: string }
                | { __typename?: 'Lot', id: string }
                | { __typename?: 'Structure', id: string }
                | { __typename?: 'Unit', id: string }
               | null | undefined }
            | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
            | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
            | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
            | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
            | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
            | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
          > }
      , canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type ToggleDocumentAsFavoritedMutationVariables = Types.Exact<{
  input: Types.ToggleDocumentAsFavoritedInput;
}>;


export type ToggleDocumentAsFavoritedMutation = { __typename?: 'Mutation', toggleDocumentAsFavorited: { __typename?: 'ToggleDocumentAsFavoritedResult', document: { __typename?: 'Document', id: string, isFavorited: boolean } } };

export type DeleteDocumentsMutationVariables = Types.Exact<{
  input: Types.DeleteEntitiesInput;
}>;


export type DeleteDocumentsMutation = { __typename?: 'Mutation', deleteDocuments: { __typename?: 'DeleteDocumentsResult', parents: Array<
      | { __typename?: 'Development', id: string }
      | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
    > } };

export type DocumentsPageProjectDetail_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Region_Fragment = { __typename?: 'Region', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Market_Fragment = { __typename?: 'Market', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Community_Fragment = { __typename?: 'Community', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetail_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, googleDriveFolderId?: string | null | undefined, childrenRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Region', id: string, name: string, parent?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined }
    | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string } }
    | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string } }
    | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string } }
    | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string } }
    | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string } }
  > };

export type DocumentsPageProjectDetailFragment =
  | DocumentsPageProjectDetail_StandaloneProject_Fragment
  | DocumentsPageProjectDetail_Region_Fragment
  | DocumentsPageProjectDetail_Market_Fragment
  | DocumentsPageProjectDetail_Community_Fragment
  | DocumentsPageProjectDetail_Subdivision_Fragment
  | DocumentsPageProjectDetail_Lot_Fragment
  | DocumentsPageProjectDetail_Structure_Fragment
  | DocumentsPageProjectDetail_Unit_Fragment
;

export type DocumentsPageDocumentDetailFragment = { __typename?: 'Document', id: string, name: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, parent:
    | { __typename?: 'Development', id: string }
    | { __typename?: 'PlanPackage', id: string }
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  , associatedProjects: Array<
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  >, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } };

export type DocumentsPageDocumentParent_Development_Fragment = { __typename?: 'Development', id: string };

export type DocumentsPageDocumentParent_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined };

export type DocumentsPageDocumentParent_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string };

export type DocumentsPageDocumentParent_Region_Fragment = { __typename?: 'Region', id: string };

export type DocumentsPageDocumentParent_Market_Fragment = { __typename?: 'Market', id: string };

export type DocumentsPageDocumentParent_Community_Fragment = { __typename?: 'Community', id: string };

export type DocumentsPageDocumentParent_Subdivision_Fragment = { __typename?: 'Subdivision', id: string };

export type DocumentsPageDocumentParent_Lot_Fragment = { __typename?: 'Lot', id: string };

export type DocumentsPageDocumentParent_Structure_Fragment = { __typename?: 'Structure', id: string };

export type DocumentsPageDocumentParent_Unit_Fragment = { __typename?: 'Unit', id: string };

export type DocumentsPageDocumentParentFragment =
  | DocumentsPageDocumentParent_Development_Fragment
  | DocumentsPageDocumentParent_PlanPackage_Fragment
  | DocumentsPageDocumentParent_StandaloneProject_Fragment
  | DocumentsPageDocumentParent_Region_Fragment
  | DocumentsPageDocumentParent_Market_Fragment
  | DocumentsPageDocumentParent_Community_Fragment
  | DocumentsPageDocumentParent_Subdivision_Fragment
  | DocumentsPageDocumentParent_Lot_Fragment
  | DocumentsPageDocumentParent_Structure_Fragment
  | DocumentsPageDocumentParent_Unit_Fragment
;

export const DocumentsPageProjectDetailFragmentDoc = gql`
    fragment DocumentsPageProjectDetail on Project {
  id
  name
  googleDriveFolderId
  childrenRecursive {
    id
    name
    parent {
      id
    }
  }
}
    `;
export const DocumentsPageDocumentDetailFragmentDoc = gql`
    fragment DocumentsPageDocumentDetail on Document {
  ...DocumentDetail
  canEdit {
    ...PotentialOperationDetails
  }
  canArchive {
    ...PotentialOperationDetails
  }
}
    ${DocumentDetailFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const DocumentsPageDocumentParentFragmentDoc = gql`
    fragment DocumentsPageDocumentParent on DocumentParent {
  ... on Project {
    id
  }
  ... on Development {
    id
  }
  ... on PlanPackage {
    id
    aggregateDraft {
      id
    }
  }
}
    `;
export const DocumentsPageMetadataDocument = gql`
    query DocumentsPageMetadata($parentId: ID!, $skipDevelopment: Boolean!, $skipProject: Boolean!) {
  documentTypes(systemControlled: false) {
    ...DocumentDetailDocumentType
  }
  documentCategories {
    name
    code
  }
  development(id: $parentId) @skip(if: $skipDevelopment) {
    ...NamedDevelopmentCohortsProjects
  }
  project(id: $parentId) @skip(if: $skipProject) {
    ...DocumentsPageProjectDetail
  }
}
    ${DocumentDetailDocumentTypeFragmentDoc}
${NamedDevelopmentCohortsProjectsFragmentDoc}
${DocumentsPageProjectDetailFragmentDoc}`;

/**
 * __useDocumentsPageMetadataQuery__
 *
 * To run a query within a React component, call `useDocumentsPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsPageMetadataQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      skipDevelopment: // value for 'skipDevelopment'
 *      skipProject: // value for 'skipProject'
 *   },
 * });
 */
export function useDocumentsPageMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables> & ({ variables: DocumentsPageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>(DocumentsPageMetadataDocument, options);
      }
export function useDocumentsPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>(DocumentsPageMetadataDocument, options);
        }
// @ts-ignore
export function useDocumentsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>;
export function useDocumentsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsPageMetadataQuery | undefined, DocumentsPageMetadataQueryVariables>;
export function useDocumentsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>(DocumentsPageMetadataDocument, options);
        }
export type DocumentsPageMetadataQueryHookResult = ReturnType<typeof useDocumentsPageMetadataQuery>;
export type DocumentsPageMetadataLazyQueryHookResult = ReturnType<typeof useDocumentsPageMetadataLazyQuery>;
export type DocumentsPageMetadataSuspenseQueryHookResult = ReturnType<typeof useDocumentsPageMetadataSuspenseQuery>;
export type DocumentsPageMetadataQueryResult = Apollo.QueryResult<DocumentsPageMetadataQuery, DocumentsPageMetadataQueryVariables>;
export const DocumentsPageDocument = gql`
    query DocumentsPage($filter: DocumentsFilter!, $page: PageFilter!) {
  documents: documentsPage(filter: $filter, page: $page) {
    entities {
      ...DocumentsPageDocumentDetail
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${DocumentsPageDocumentDetailFragmentDoc}`;

/**
 * __useDocumentsPageQuery__
 *
 * To run a query within a React component, call `useDocumentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDocumentsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsPageQuery, DocumentsPageQueryVariables> & ({ variables: DocumentsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsPageQuery, DocumentsPageQueryVariables>(DocumentsPageDocument, options);
      }
export function useDocumentsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsPageQuery, DocumentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsPageQuery, DocumentsPageQueryVariables>(DocumentsPageDocument, options);
        }
// @ts-ignore
export function useDocumentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageQuery, DocumentsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsPageQuery, DocumentsPageQueryVariables>;
export function useDocumentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageQuery, DocumentsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsPageQuery | undefined, DocumentsPageQueryVariables>;
export function useDocumentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsPageQuery, DocumentsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentsPageQuery, DocumentsPageQueryVariables>(DocumentsPageDocument, options);
        }
export type DocumentsPageQueryHookResult = ReturnType<typeof useDocumentsPageQuery>;
export type DocumentsPageLazyQueryHookResult = ReturnType<typeof useDocumentsPageLazyQuery>;
export type DocumentsPageSuspenseQueryHookResult = ReturnType<typeof useDocumentsPageSuspenseQuery>;
export type DocumentsPageQueryResult = Apollo.QueryResult<DocumentsPageQuery, DocumentsPageQueryVariables>;
export const DocumentsAssetDocument = gql`
    query DocumentsAsset($filter: DocumentsFilter!) {
  documents(filter: $filter) {
    id
    name
    asset {
      ...AssetInfo
    }
  }
}
    ${AssetInfoFragmentDoc}`;

/**
 * __useDocumentsAssetQuery__
 *
 * To run a query within a React component, call `useDocumentsAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsAssetQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDocumentsAssetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsAssetQuery, DocumentsAssetQueryVariables> & ({ variables: DocumentsAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsAssetQuery, DocumentsAssetQueryVariables>(DocumentsAssetDocument, options);
      }
export function useDocumentsAssetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsAssetQuery, DocumentsAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsAssetQuery, DocumentsAssetQueryVariables>(DocumentsAssetDocument, options);
        }
// @ts-ignore
export function useDocumentsAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentsAssetQuery, DocumentsAssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsAssetQuery, DocumentsAssetQueryVariables>;
export function useDocumentsAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsAssetQuery, DocumentsAssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsAssetQuery | undefined, DocumentsAssetQueryVariables>;
export function useDocumentsAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsAssetQuery, DocumentsAssetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentsAssetQuery, DocumentsAssetQueryVariables>(DocumentsAssetDocument, options);
        }
export type DocumentsAssetQueryHookResult = ReturnType<typeof useDocumentsAssetQuery>;
export type DocumentsAssetLazyQueryHookResult = ReturnType<typeof useDocumentsAssetLazyQuery>;
export type DocumentsAssetSuspenseQueryHookResult = ReturnType<typeof useDocumentsAssetSuspenseQuery>;
export type DocumentsAssetQueryResult = Apollo.QueryResult<DocumentsAssetQuery, DocumentsAssetQueryVariables>;
export const ScheduleTasksForDocumentParentDocument = gql`
    query ScheduleTasksForDocumentParent($parentId: ID!) {
  scheduleTasks(
    filter: {scheduleParent: [$parentId], status: [NOT_STARTED, IN_PROGRESS, COMPLETE, ON_HOLD, DELAYED]}
    first: 10000
  ) {
    ...ScheduleTaskInfo
  }
}
    ${ScheduleTaskInfoFragmentDoc}`;

/**
 * __useScheduleTasksForDocumentParentQuery__
 *
 * To run a query within a React component, call `useScheduleTasksForDocumentParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTasksForDocumentParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTasksForDocumentParentQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useScheduleTasksForDocumentParentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables> & ({ variables: ScheduleTasksForDocumentParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>(ScheduleTasksForDocumentParentDocument, options);
      }
export function useScheduleTasksForDocumentParentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>(ScheduleTasksForDocumentParentDocument, options);
        }
// @ts-ignore
export function useScheduleTasksForDocumentParentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>;
export function useScheduleTasksForDocumentParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleTasksForDocumentParentQuery | undefined, ScheduleTasksForDocumentParentQueryVariables>;
export function useScheduleTasksForDocumentParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>(ScheduleTasksForDocumentParentDocument, options);
        }
export type ScheduleTasksForDocumentParentQueryHookResult = ReturnType<typeof useScheduleTasksForDocumentParentQuery>;
export type ScheduleTasksForDocumentParentLazyQueryHookResult = ReturnType<typeof useScheduleTasksForDocumentParentLazyQuery>;
export type ScheduleTasksForDocumentParentSuspenseQueryHookResult = ReturnType<typeof useScheduleTasksForDocumentParentSuspenseQuery>;
export type ScheduleTasksForDocumentParentQueryResult = Apollo.QueryResult<ScheduleTasksForDocumentParentQuery, ScheduleTasksForDocumentParentQueryVariables>;
export const DocumentEditorDocument = gql`
    query DocumentEditor($documentId: ID!, $versionId: ID) {
  document(id: $documentId, versionId: $versionId) {
    ...DocumentEditorDetail
  }
  internalUsers {
    ...InternalUserDetail
  }
}
    ${DocumentEditorDetailFragmentDoc}
${InternalUserDetailFragmentDoc}`;

/**
 * __useDocumentEditorQuery__
 *
 * To run a query within a React component, call `useDocumentEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentEditorQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDocumentEditorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentEditorQuery, DocumentEditorQueryVariables> & ({ variables: DocumentEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentEditorQuery, DocumentEditorQueryVariables>(DocumentEditorDocument, options);
      }
export function useDocumentEditorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentEditorQuery, DocumentEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentEditorQuery, DocumentEditorQueryVariables>(DocumentEditorDocument, options);
        }
// @ts-ignore
export function useDocumentEditorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentEditorQuery, DocumentEditorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentEditorQuery, DocumentEditorQueryVariables>;
export function useDocumentEditorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentEditorQuery, DocumentEditorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentEditorQuery | undefined, DocumentEditorQueryVariables>;
export function useDocumentEditorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentEditorQuery, DocumentEditorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentEditorQuery, DocumentEditorQueryVariables>(DocumentEditorDocument, options);
        }
export type DocumentEditorQueryHookResult = ReturnType<typeof useDocumentEditorQuery>;
export type DocumentEditorLazyQueryHookResult = ReturnType<typeof useDocumentEditorLazyQuery>;
export type DocumentEditorSuspenseQueryHookResult = ReturnType<typeof useDocumentEditorSuspenseQuery>;
export type DocumentEditorQueryResult = Apollo.QueryResult<DocumentEditorQuery, DocumentEditorQueryVariables>;
export const DocumentsForParentDocument = gql`
    query DocumentsForParent($parentId: ID!) {
  documents(filter: {parentIds: [$parentId]}) {
    ...DocumentsPageDocumentDetail
  }
}
    ${DocumentsPageDocumentDetailFragmentDoc}`;

/**
 * __useDocumentsForParentQuery__
 *
 * To run a query within a React component, call `useDocumentsForParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsForParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsForParentQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useDocumentsForParentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsForParentQuery, DocumentsForParentQueryVariables> & ({ variables: DocumentsForParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsForParentQuery, DocumentsForParentQueryVariables>(DocumentsForParentDocument, options);
      }
export function useDocumentsForParentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsForParentQuery, DocumentsForParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsForParentQuery, DocumentsForParentQueryVariables>(DocumentsForParentDocument, options);
        }
// @ts-ignore
export function useDocumentsForParentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentsForParentQuery, DocumentsForParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsForParentQuery, DocumentsForParentQueryVariables>;
export function useDocumentsForParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsForParentQuery, DocumentsForParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentsForParentQuery | undefined, DocumentsForParentQueryVariables>;
export function useDocumentsForParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentsForParentQuery, DocumentsForParentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentsForParentQuery, DocumentsForParentQueryVariables>(DocumentsForParentDocument, options);
        }
export type DocumentsForParentQueryHookResult = ReturnType<typeof useDocumentsForParentQuery>;
export type DocumentsForParentLazyQueryHookResult = ReturnType<typeof useDocumentsForParentLazyQuery>;
export type DocumentsForParentSuspenseQueryHookResult = ReturnType<typeof useDocumentsForParentSuspenseQuery>;
export type DocumentsForParentQueryResult = Apollo.QueryResult<DocumentsForParentQuery, DocumentsForParentQueryVariables>;
export const DocumentCategoriesDocument = gql`
    query DocumentCategories {
  documentCategories {
    name
    code
  }
}
    `;

/**
 * __useDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
      }
export function useDocumentCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
        }
// @ts-ignore
export function useDocumentCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>;
export function useDocumentCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentCategoriesQuery | undefined, DocumentCategoriesQueryVariables>;
export function useDocumentCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>(DocumentCategoriesDocument, options);
        }
export type DocumentCategoriesQueryHookResult = ReturnType<typeof useDocumentCategoriesQuery>;
export type DocumentCategoriesLazyQueryHookResult = ReturnType<typeof useDocumentCategoriesLazyQuery>;
export type DocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useDocumentCategoriesSuspenseQuery>;
export type DocumentCategoriesQueryResult = Apollo.QueryResult<DocumentCategoriesQuery, DocumentCategoriesQueryVariables>;
export const SaveDocumentsDocument = gql`
    mutation SaveDocuments($input: [SaveDocumentInput!]!) {
  saveDocuments(input: {documents: $input}) {
    documents {
      id
      ...DocumentEditorDetail
      parent {
        ...DocumentsPageDocumentParent
      }
    }
  }
}
    ${DocumentEditorDetailFragmentDoc}
${DocumentsPageDocumentParentFragmentDoc}`;
export type SaveDocumentsMutationFn = Apollo.MutationFunction<SaveDocumentsMutation, SaveDocumentsMutationVariables>;

/**
 * __useSaveDocumentsMutation__
 *
 * To run a mutation, you first call `useSaveDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentsMutation, { data, loading, error }] = useSaveDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDocumentsMutation, SaveDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDocumentsMutation, SaveDocumentsMutationVariables>(SaveDocumentsDocument, options);
      }
export type SaveDocumentsMutationHookResult = ReturnType<typeof useSaveDocumentsMutation>;
export type SaveDocumentsMutationResult = Apollo.MutationResult<SaveDocumentsMutation>;
export type SaveDocumentsMutationOptions = Apollo.BaseMutationOptions<SaveDocumentsMutation, SaveDocumentsMutationVariables>;
export const ToggleDocumentAsFavoritedDocument = gql`
    mutation ToggleDocumentAsFavorited($input: ToggleDocumentAsFavoritedInput!) {
  toggleDocumentAsFavorited(input: $input) {
    document {
      id
      isFavorited
    }
  }
}
    `;
export type ToggleDocumentAsFavoritedMutationFn = Apollo.MutationFunction<ToggleDocumentAsFavoritedMutation, ToggleDocumentAsFavoritedMutationVariables>;

/**
 * __useToggleDocumentAsFavoritedMutation__
 *
 * To run a mutation, you first call `useToggleDocumentAsFavoritedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDocumentAsFavoritedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDocumentAsFavoritedMutation, { data, loading, error }] = useToggleDocumentAsFavoritedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleDocumentAsFavoritedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleDocumentAsFavoritedMutation, ToggleDocumentAsFavoritedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleDocumentAsFavoritedMutation, ToggleDocumentAsFavoritedMutationVariables>(ToggleDocumentAsFavoritedDocument, options);
      }
export type ToggleDocumentAsFavoritedMutationHookResult = ReturnType<typeof useToggleDocumentAsFavoritedMutation>;
export type ToggleDocumentAsFavoritedMutationResult = Apollo.MutationResult<ToggleDocumentAsFavoritedMutation>;
export type ToggleDocumentAsFavoritedMutationOptions = Apollo.BaseMutationOptions<ToggleDocumentAsFavoritedMutation, ToggleDocumentAsFavoritedMutationVariables>;
export const DeleteDocumentsDocument = gql`
    mutation DeleteDocuments($input: DeleteEntitiesInput!) {
  deleteDocuments(input: $input) {
    parents {
      ...DocumentsPageDocumentParent
    }
  }
}
    ${DocumentsPageDocumentParentFragmentDoc}`;
export type DeleteDocumentsMutationFn = Apollo.MutationFunction<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>;

/**
 * __useDeleteDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentsMutation, { data, loading, error }] = useDeleteDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>(DeleteDocumentsDocument, options);
      }
export type DeleteDocumentsMutationHookResult = ReturnType<typeof useDeleteDocumentsMutation>;
export type DeleteDocumentsMutationResult = Apollo.MutationResult<DeleteDocumentsMutation>;
export type DeleteDocumentsMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentsMutation, DeleteDocumentsMutationVariables>;